import React from 'react';
import type { SVGDefaultProps } from './types';
import { colors } from '@/styles';

export const RadioOutlinedCircleUnselect = ({
  size = 16,
  title = 'Select',
  fill = colors.boulder,
}: SVGDefaultProps) => {
  const height = Number(size) * 2.85;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" height={height} viewBox="0 0 14 14">
      {Boolean(title) && <title>{title}</title>}
      <circle cx="7" cy="7" r="6" stroke={fill} strokeWidth="1" fill="none" />
    </svg>
  );
};
